// extracted by mini-css-extract-plugin
module.exports = {"disable":"styles_disable___4UP3"};